import { LinkButton, LinkButtonProps } from '@/ui/Button';
import { cx } from '@/ui/cva';

export function SocialButton({
    className,
    ...props
}: Omit<LinkButtonProps, 'target' | 'variant' | 'color'>) {
    return (
        <LinkButton
            {...props}
            className={cx(
                'space-x-xs py-2.5 text-sm',
                className,
                'hover:text-white'
            )}
            target="_blank"
            variant="outlined"
        />
    );
}
